// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ClientTransactionTable_tableWrapper__9suyN","table":"ClientTransactionTable_table__fxRMp"};